import React from 'react'
import { Avatar, Box } from '@mui/material'
import { IProjectAuthorShort } from '../../../api/types/projects'
import {
  getUserInitialsFromDisplayName,
  resolveUserAvatarUrl,
  resolveUserDisplayName,
} from '../../../utils/deletedUserDisplay'

type Props = {
  users?: IProjectAuthorShort[] | null
  size?: number
  max?: number
  overlap?: number
}

export const StackedAvatars = ({ users, size = 24, max = 3, overlap = 8 }: Props) => {
  const list = (users ?? []).slice(0, max)
  if (list.length === 0) return null

  return (
    <Box display="flex" alignItems="center">
      {list.map((u, idx) => {
        const title = resolveUserDisplayName(u)
        return (
        <Avatar
          key={`${u.id ?? 'deleted'}-${idx}`}
          src={resolveUserAvatarUrl(u)}
          alt={title}
          sx={{
            width: size,
            height: size,
            fontSize: Math.max(10, Math.floor(size * 0.4)),
            border: '2px solid',
            borderColor: 'background.paper',
            ml: idx === 0 ? 0 : `-${overlap}px`,
            zIndex: list.length - idx,
            bgcolor: 'grey.400',
          }}
        >
          {getUserInitialsFromDisplayName(title)}
        </Avatar>
        )
      })}
    </Box>
  )
}

